import axios from "axios";
import config from "../config";
export default {
  getOrganizers(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "organizer",
      method: "GET"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  },
  createOrganizer(context, success, error) {
    axios({
      url: config.URLS.i5Scheduler + "organizer",
      data: context.addOrganizerPayLoad,
      method: "POST"
    })
      .then(response => {
        success(response.data);
      })
      .catch(errorResponse => {
        error(errorResponse);
      });
  }
};
